module.exports = __webpack_public_path__ + "static/media/supple.ad3cd433.svg";